import {EventEmitter} from '@angular/core';
import {Endpoint} from './Endpoint';
export class EndpointRegistry {

    static list = [];

    static listChange = new EventEmitter<any>();
/**
 * @param {?} endpoint
 * @return {?}
 */
static register(endpoint: Endpoint) {
        this.list.push(endpoint);
        this.listChange.emit(this.list);
    }
/**
 * @return {?}
 */
static getOrganizedList() {
        let /** @type {?} */ modules = {};
        for (let /** @type {?} */ endpoint of EndpointRegistry.list) {
            if (!modules[endpoint.module]) {
                modules[endpoint.module] = [];
            }
            modules[endpoint.module].push(endpoint);
        }
        return modules;
    }
}

function EndpointRegistry_tsickle_Closure_declarations() {
/** @type {?} */
EndpointRegistry.list;
/** @type {?} */
EndpointRegistry.listChange;
}

